/**
 * Site footer copy and external URLs (aligned with coolture_platform).
 * Replace with i18n keys when react-i18next is added.
 */
export const footerCopy = {
  copyright: 'Kincode',
  termsAndConditions: 'Terms and conditions',
  privacyPolicy: 'Privacy policy',
  serviceStatus: 'Service status',
} as const;

export const footerLinks = {
  kincodeHome: 'https://www.kincode.ai',
  termsAndConditions: 'https://kincode.ai/terms-and-conditions',
  privacyPolicy: 'https://kincode.ai/privacy-policy',
  serviceStatus: 'https://status.kincode.ai',
} as const;
